// extracted by css-extract-rspack-plugin
export default {"bui-TablePagination":"Z_Iagacz0F1YYG04","bui-TablePaginationLeft":"N_pRbW6lVsY4Hdgf","bui-TablePaginationRight":"qXYnm03BkEcKl1FA","bui-TablePaginationSelect":"plzZlLJyZhc3wn3s"};